import { render } from "./ErrorAlertComponent.vue?vue&type=template&id=70d192b0&scoped=true"
import script from "./ErrorAlertComponent.vue?vue&type=script&lang=js"
export * from "./ErrorAlertComponent.vue?vue&type=script&lang=js"

import "./ErrorAlertComponent.vue?vue&type=style&index=0&id=70d192b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d192b0"]])

export default __exports__